<template lang="pug">
label.label(v-if="label" :for="name") {{label}}
FormField(v-slot="$field" :name="name")
  Textarea(
    v-model="$field.value"
    :rows="$attrs.rows"
    :class="$attrs.class"
    :id="$attrs.id || name"
    :placeholder="$attrs.placeholder"
    :autoResize="autoResize"
    fluid
  )
  Message(v-if="$field?.invalid && ($field?.touched || formSubmitted)" severity="error" size="small" variant="simple") {{ $field.error?.message }}
</template>

<script setup>
import { inject, ref } from 'vue'
import Textarea from 'primevue/textarea'
import { FormField } from '@primevue/forms';
import Message from 'primevue/message';

const formSubmitted = inject('appFormSubmitted', ref(false))

const props = defineProps({
  name:       { type: String, required: true },
  label:      { type: String, required: false },
  autoResize: { type: Boolean, default: true },
})

defineOptions({inheritAttrs: false})
</script>